// Import Dependencies
import { Outlet, ScrollRestoration } from "react-router";
import { lazy, useState, useEffect } from "react";
import { useAuthContext } from "app/presentation/contexts/auth/context";

// Local Imports
import { SplashScreen } from "app/presentation/components/template/SplashScreen";
import { Progress } from "app/presentation/components/template/Progress";
import { Loadable } from "app/presentation/components/shared/Loadable";

const Toaster = Loadable(lazy(() => import("app/presentation/components/template/Toaster")));
const Tooltip = Loadable(lazy(() => import("app/presentation/components/template/Tooltip")));

// ----------------------------------------------------------------------

function Root() {
  const { isInitialized } = useAuthContext();
  // Safety timeout to prevent infinite splash screen
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    if (isInitialized) {
      setShowSplash(false);
      return;
    }

    // Force show app after 5 seconds even if not initialized (fallback)
    const timer = setTimeout(() => {
      console.warn('⚠️ Root - Auth initialization timeout (5s). Forcing render.');
      setShowSplash(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, [isInitialized]);

  if (showSplash) {
    return <SplashScreen />;
  }

  return (
    <>
      <Progress />
      <ScrollRestoration />
      <Outlet />
      <Tooltip />
      <Toaster />
    </>
  );
}

export default Root;